import React from "react";
import CategoryPage from "./CategoryPage";

function State({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="State"
      parentCategory="News"
      posts={posts}
      publications={publications}
    />
  );

}

export default State;